module.exports = __webpack_public_path__ + "img/mobile-slider1.8c5aa137.png";